import React, { memo, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { createSelector } from 'reselect';

import { logging, logPostInfo } from '../../actions/log';
import { CONTEXT } from '../../config';
import Button from '../Button/Button';
import AButton from '../AButton/AButton';
import styles from './SoftCardSearch.module.less';

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoft,
);

const selectUpgradeSofts = createSelector(
  state => state.native,
  native => native.upgradeSofts,
);

export default memo(({ soft, logInfo, lenovoWords, firstapp }) => {
  const history = useHistory();
  const upgradeSofts = useSelector(selectUpgradeSofts); // 可更新
  const installedSofts = useSelector(selectInstalledSoft); // 已经安装
  const dispatch = useDispatch();

  // 1. 联系词softcard 做特殊处理 (即：将其作为搜索结果点击进入详情处理)
  // 首位应用进入详情页面的时候，重置两次logPostInfo（即：让source，source_p，source_p后移一步，logInfo.source = 'Search'）
  // 详情页中通过source_p==='Search'判断来源是否来自搜索
  const handleSoftCard = useCallback(() => {
    dispatch(
      logPostInfo({
        source: logInfo.source,
        source_p: logInfo.source_p,
        source_pp: logInfo.source_pp,
      }),
    );
  }, [dispatch]);

  /**
   * 点击安装或者升级  进入搜索结果页面
   */
  const handleSoftCardBtn = useCallback(
    softInfo => {
      const findInst = installedSofts.find(
        soft_ => soft_.softID === softInfo.softID || soft_.SoftID === softInfo.softID,
      );
      const findUpdate = upgradeSofts.find(
        soft_ => soft_.softID === softInfo.softID || soft_.SoftID === softInfo.softID,
      );

      // 即点击安装或者更新跳入搜索结果页
      if (!findInst || (findInst && findUpdate)) {
        if (softInfo.androidType === '1') {
          history.push(
            `${CONTEXT}/search/soft?keyword=${encodeURIComponent(softInfo.softName)}&firstId=${
              softInfo.packageName
            }&androidType=${softInfo.androidType || '0'}`,
          );
        } else {
          history.push(
            `${CONTEXT}/search/soft?keyword=${encodeURIComponent(softInfo.softName)}&firstId=${
              softInfo.softID
            }&androidType=${softInfo.androidType || '0'}`,
          );
        }
      }
    },
    [dispatch, upgradeSofts, installedSofts],
  );

  useEffect(() => {
    if (logInfo.changeIndex === null && lenovoWords.kw === logInfo.search_word && firstapp) {
      dispatch(
        logging({
          category: 'I',
          action: 'Search_Lenovo_Firstapp',
          label: '',
          param2: {
            source: logInfo.source,
            search_type: logInfo.search_type,
            search_word: logInfo.search_word,
            softid: soft.androidType === '1' ? soft.packageName : soft.softID,
            softType: soft.androidType === '1' ? '1' : '0',
          },
          param3: soft.bizInfo,
        }),
      );
    }
  }, [dispatch, soft, lenovoWords, firstapp]);

  return (
    <div className={styles.soft_card}>
      <Link
        className={styles.soft_card_img_box}
        to={{
          pathname:
            soft.androidType === '1'
              ? `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo || '{}'}`
              : `${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}`,
        }}
        onClick={() => {
          handleSoftCard(soft);
        }}
      >
        <img className={styles.soft_card_img} src={soft.logoFile} alt="" />
        {soft.androidType === '1' && <div className={styles.soft_card_logo} />}
      </Link>
      <div className={styles.soft_card_box}>
        <Link
          to={{
            pathname:
              soft.androidType === '1'
                ? `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo ||
                    '{}'}`
                : `${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}`,
          }}
          onClick={() => {
            handleSoftCard(soft);
          }}
        >
          <div
            className={styles.soft_card_title}
            dangerouslySetInnerHTML={{ __html: soft.softNameShow }}
            title={soft.keyWord}
          />
          <div className={styles.soft_card_desc}>{soft.downloadCount || 0}安装</div>
        </Link>
        <div
          className={styles.soft_card_opt}
          onClick={e => {
            handleSoftCardBtn(soft);
          }}
        >
          {soft.androidType === '1' ? (
            <AButton
              soft={soft}
              info={{ text: '安装' }}
              // 联系词softcard 做特殊处理  所以source_p, source_pp 通过父组件传入
              logInfo={{ ...logInfo }}
            />
          ) : (
            <Button
              soft={soft}
              info={{ text: '安装' }}
              // 联系词softcard 做特殊处理  所以source_p, source_pp 通过父组件传入
              logInfo={{ ...logInfo }}
            />
          )}
        </div>
      </div>
    </div>
  );
});
